import React from 'react';
import { motion } from 'framer-motion';
import { Target, Beaker, CheckCircle, FileText } from 'lucide-react';
import { ScrollArea } from '../ui/scroll-area';

const TechnicalDeepDive = ({ technical }) => {
  if (!technical) {
    return (
      <div className="text-center py-12 text-slate-400">
        <Beaker className="w-12 h-12 mx-auto mb-3 opacity-50" />
        <p>Technical analysis not available</p>
      </div>
    );
  }

  const sections = [
    { 
      key: 'objective', 
      label: 'Objective', 
      icon: Target, 
      color: 'text-teal-400',
      bgColor: 'bg-teal-400/10',
      borderColor: 'border-teal-400/30'
    },
    { 
      key: 'methodology', 
      label: 'Methodology', 
      icon: Beaker, 
      color: 'text-emerald-400',
      bgColor: 'bg-emerald-400/10',
      borderColor: 'border-emerald-400/30'
    },
    { 
      key: 'results', 
      label: 'Results', 
      icon: CheckCircle, 
      color: 'text-amber-400',
      bgColor: 'bg-amber-400/10',
      borderColor: 'border-amber-400/30'
    },
    { 
      key: 'conclusion', 
      label: 'Conclusion', 
      icon: FileText, 
      color: 'text-purple-400',
      bgColor: 'bg-purple-400/10',
      borderColor: 'border-purple-400/30'
    }
  ];

  return (
    <div className="space-y-6" data-testid="technical-deep-dive">
      <div className="flex items-center gap-3 mb-6">
        <div className="p-2 rounded-xl bg-slate-800">
          <Beaker className="w-5 h-5 text-teal-400" />
        </div>
        <h2 className="text-xl font-heading font-bold text-white">Technical Deep-Dive</h2>
      </div>

      {/* Technical Sections */}
      <div className="space-y-4">
        {sections.map((section, index) => {
          const Icon = section.icon;
          const value = technical[section.key] || 'Not clearly stated';
          
          return (
            <motion.div
              key={section.key}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className={`rounded-xl ${section.bgColor} border ${section.borderColor} overflow-hidden`}
            >
              {/* Section Header */}
              <div className={`px-4 py-3 border-b ${section.borderColor} bg-slate-900/30`}>
                <div className="flex items-center gap-2">
                  <Icon className={`w-4 h-4 ${section.color}`} />
                  <span className={`text-sm font-mono font-semibold ${section.color}`}>
                    {section.label}
                  </span>
                </div>
              </div>
              
              {/* Section Content - Full text display */}
              <div className="p-4">
                <p className="text-slate-300 font-body leading-relaxed whitespace-pre-wrap">
                  {value}
                </p>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default TechnicalDeepDive;
